"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _compact = _interopRequireDefault(require("lodash/fp/compact"));
var _split = _interopRequireDefault(require("lodash/fp/split"));
var _RegularMenuItem = _interopRequireDefault(require("../MenuItem/RegularMenuItem"));
var _useSearchMenuContext2 = _interopRequireDefault(require("../SearchInput/useSearchMenuContext"));
var _excluded = ["children", "disabled", "rawLabel", "postIcon", "value", "ignoreCase"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getSegments = function getSegments(text, separator, ignoreCase) {
  return (0, _compose["default"])(_compact["default"], (0, _split["default"])(new RegExp("(".concat(separator, ")"), ignoreCase ? 'gi' : 'g')))(text);
};
var isMatch = function isMatch(text1, text2, ignoreCase) {
  return text1.match(new RegExp("^".concat(text2, "$"), ignoreCase ? 'i' : ''));
};
var HighlightMenuItem = function HighlightMenuItem(_ref) {
  var text = _ref.text,
    keyword = _ref.keyword,
    postIcon = _ref.postIcon,
    ignoreCase = _ref.ignoreCase;
  var segments = (0, _react.useMemo)(function () {
    return getSegments(text, keyword, ignoreCase);
  }, [text, keyword, ignoreCase]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-truncate mg-r-6"
  }, segments.map(function (segment, i) {
    return isMatch(segment, keyword, ignoreCase) ? /*#__PURE__*/_react["default"].createElement("span", {
      key: segment + i,
      className: "text-grey-100 fw-bold"
    }, segment) : segment;
  })), postIcon);
};
var MenuSuggestionItem = function MenuSuggestionItem(_ref2) {
  var children = _ref2.children,
    disabled = _ref2.disabled,
    rawLabel = _ref2.rawLabel,
    postIcon = _ref2.postIcon,
    value = _ref2.value,
    _ref2$ignoreCase = _ref2.ignoreCase,
    ignoreCase = _ref2$ignoreCase === void 0 ? true : _ref2$ignoreCase,
    regularProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useSearchMenuContext = (0, _useSearchMenuContext2["default"])(),
    searchText = _useSearchMenuContext.searchText;
  return /*#__PURE__*/_react["default"].createElement(_RegularMenuItem["default"], (0, _extends2["default"])({
    className: "menu-item-search",
    disabled: disabled,
    value: value
  }, regularProps), children !== null && children !== void 0 ? children : rawLabel && /*#__PURE__*/_react["default"].createElement(HighlightMenuItem, {
    text: rawLabel,
    keyword: searchText,
    postIcon: postIcon,
    ignoreCase: ignoreCase
  }));
};
var Composed = (0, _compose["default"])(_react.memo)(MenuSuggestionItem);
Composed.displayName = 'MenuSuggestionItem';
var _default = exports["default"] = Composed;